import {
  forwardRef,
  DetailedHTMLProps,
  InputHTMLAttributes,
  HTMLInputTypeAttribute,
} from "react";
import classNames from "classnames";

export type InputProps = {
  id: string;
  name: string;
  label: string;
  type?: HTMLInputTypeAttribute;
  className?: string;
  showLabel?: boolean;
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      id,
      name,
      label,
      type = "text",
      className = "",
      placeholder,
      showLabel,
      ...props
    },
    ref,
  ) => {
    return (
      <>
        {showLabel && <span className="text-sm">{label}</span>}
        <input
          id={id}
          ref={ref}
          name={name}
          type={type}
          aria-label={label}
          placeholder={placeholder}
          data-cy={`${name}-input`}
          className={classNames(
            `relative
                    inline-flex
                    min-h-[48px]
                    w-full
                    rounded-lg 
                    border 
                    border-gray-100 
                    bg-white
                    px-4 py-2 
                    leading-none
                    text-gray-900 
                    placeholder-gray-500 
                    transition-colors
                    ease-in-out
                    hover:border-th-primary-400
                    focus:border-th-primary-100
                    focus:outline-none 
                    focus:ring-2
                    focus:ring-th-primary-100
                    focus:ring-opacity-30`,
            className,
          )}
          {...props}
        />
      </>
    );
  },
);

Input.displayName = "Input";

export { Input };
